// Where a deployment serves the token endpoint of its applications, as the deploy renders its
// gateway: on the regulated mTLS host (`matls-auth.<domínio>`), on the terminated auth host
// (`auth.<domínio>`), or on neither, when the deployment provisions no gateway route to its
// Keycloak (a Keycloak the deploy does not operate, or no gateway). The runtime deploy states it to
// Power, which hands it to the admin; nothing downstream derives it again.
import { Schema } from 'effect';

export const TOKEN_ENDPOINT_HOSTS = ['matls-auth', 'auth', 'unprovisioned'] as const;

export const TokenEndpointHost = Schema.Literals(TOKEN_ENDPOINT_HOSTS).annotate({
  title: 'TokenEndpointHost',
  description:
    'Where the deployment serves the application token endpoint: matls-auth, auth, or unprovisioned.',
});
export type TokenEndpointHost = typeof TokenEndpointHost.Type;
